import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import Button from 'components/Button';

export const StyledButton = styled(Button)`
  margin: ${gutters.spacing(4)}px 0 0 0;
`;
